import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GoonghapPage from "../pages/goonghap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/goonghap",
    element: <GoonghapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
